import { render, staticRenderFns } from "./ClinicRegularVideoCard.vue?vue&type=template&id=3825c12d&scoped=true"
import script from "./ClinicRegularVideoCard.vue?vue&type=script&lang=js"
export * from "./ClinicRegularVideoCard.vue?vue&type=script&lang=js"
import style0 from "./ClinicRegularVideoCard.vue?vue&type=style&index=0&id=3825c12d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3825c12d",
  null
  
)

export default component.exports